export class ConfirmUnconfim {
  locked: any;
  idutente: any;
  mese: any;
  anno: any;
}
